import moment from "moment/moment"

export default function formatApiDate(date: string|null|undefined): string|undefined {
  if(date === null || date === undefined || date === '') return undefined;
    if(!date.toString().includes('/')){
        return moment(date).format('DD/MM/YYYY')
    }else return date
}